import React from 'react';
import { SplitLoadingContext } from './types';

export const SplitContext = React.createContext<Partial<SplitLoadingContext>>({loading: true});